import ChevronRight from '@mui/icons-material/ChevronRight';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, List, ListItemIcon, MenuItem, Typography } from '@mui/material';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { StyledTheme } from '../../../styles/styleTheme';

interface SubMenuProps {
  dense: boolean;
  handleToggle: () => void;
  icon: ReactElement;
  isOpen: boolean;
  name: string;
  children: ReactNode;
  menuPath: string;
  childPaths: string[];
}

const SubMenu = (props: SubMenuProps) => {
  const { handleToggle, isOpen, name, icon, children, dense, menuPath, childPaths } = props;
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { pathname } = useLocation();

  const isActive =
    pathname.startsWith(menuPath) || childPaths.some((path) => pathname.startsWith(path));

  useEffect(() => {
    const checkSidebarState = () => {
      const sidebar = document.querySelector('.MuiDrawer-root .MuiPaper-root');
      if (sidebar) {
        const width = sidebar.getBoundingClientRect().width;
        setSidebarOpen(width > 60);
      }
    };

    checkSidebarState();

    const observer = new MutationObserver(checkSidebarState);
    const appFrame = document.querySelector('.RaLayout-appFrame') || document.body;
    observer.observe(appFrame, { attributes: true, subtree: true });

    window.addEventListener('resize', checkSidebarState);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', checkSidebarState);
    };
  }, []);

  return (
    <div>
      <MenuItem
        dense={dense}
        onClick={handleToggle}
        sx={{
          paddingLeft: 2,
          color: isActive ? StyledTheme.tealDark : 'text.secondary',
          '& .MuiListItemIcon-root': {
            color: isActive ? StyledTheme.tealDark : 'text.secondary',
          },
        }}>
        <ListItemIcon sx={{ minWidth: 5 }}>
          {sidebarOpen ? isOpen ? <ExpandMore /> : icon : <ExpandMore />}
        </ListItemIcon>
        <Typography variant='inherit' color='inherit' sx={{ marginLeft: 0.6 }}>
          {name}
        </Typography>
        {sidebarOpen && !isOpen && <ChevronRight sx={{ marginLeft: 'auto' }} />}
      </MenuItem>
      <Collapse in={isOpen} timeout='auto' unmountOnExit>
        <List
          dense={dense}
          component='div'
          disablePadding
          sx={{
            '& .MuiMenuItem-root': {
              paddingLeft: sidebarOpen ? 4 : 2,
              transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
              marginLeft: 0.3,
            },
          }}>
          {children}
        </List>
      </Collapse>
    </div>
  );
};

export default SubMenu;
